<template>
  <div>
    <template v-for="code in codeList">
      <label :key="code.code" :for="`${name}-${code.name}`">
        <input :id="`${name}-${code.name}`" type="radio" :name="`${cmnsCdGrpId}-${name}`" :value="code.code" :checked="code.code == value" @click="onClick($event.target.value)" />
        <span>
          {{ code.name }}
        </span>
      </label>
    </template>
  </div>
</template>

<script>
export default {
  name: 'RadioCodeListType3',
  props: {
    label: '',
    name: {
      type: String,
      default: 'radioCode'
    },
    cmnsCdGrpId: '',
    value: ''
  },
  data: () => ({
    codeList: []
  }),
  mounted () {
    let params = {
      cmnsCdGrpId: this.cmnsCdGrpId
    }

    this.$http
      .get('/api/appmgmt/common/code/list', {params: params, data: {isLoadingHide: 'Y'}})
      .then((result) => {
        for (let i in result.data.result) {
          this.codeList.push({code: result.data.result[i].cmnsCd, name: result.data.result[i].cmnsCdNm})
        }
      })
  },
  methods: {
    onClick (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RadioCodeListType3.vue